import { Component, OnInit, ViewChild} from '@angular/core';
import { DatePipe } from '@angular/common';
import { NavigationExtras, ActivatedRoute } from '@angular/router';
import { ActivityStoreInstructionActionFacade } from '../../../common/facade/ActivityStoreInstructionActionFacade';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { ImageViewerConfig } from 'ngx-image-viewer';
import { BlobStorageFacade } from '../../../common/facade/BlobStorageFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
    selector: 'app-action-detail',
    templateUrl: './action-detail.component.html',
    styleUrls: ['./action-detail.component.css']
})

export class ActionDetailComponent implements OnInit {
    // region Properties and Attributes

    titleCorrectiveActionsDetail = res.CorrectiveActionsDetail;
    lblStore = res.Store;
    lblDownload = res.Download;
    lblSearch = res.Search;
    lblEvaluator = res.Evaluator;
    lblResponsable = res.Responsable;
    lblRequiredDate = res.RequiredDate;
    lblSolutionDate = res.SolutionDate;
    lblInstruction = res.Instruction;
    lblCorrectiveAction = res.CorrectiveAction;
    lblStatus = res.Status;
    lblPhotos = res.Photos;
    lblClose = res.Close;
    lblSee = res.View;
    lblChecklist = res.Checklist;

    flag = true;
    language = 0;
    messagesTable: any = {
        emptyMessage: '',
        totalMessage: ''
    };

    isSpanish = true;

    @ViewChild('photoModal') photoModal;
    public loading = false;
    public rows: any = [];
    public rows2: any = [];
    public alerts: any[] = [];
    public StoreId: number;
    public photos_gallery: any = [];
    public configImageViewer: ImageViewerConfig = { customBtns: [] };
    public imageIndexOne = 0;
    public extras: NavigationExtras;
    public path = 'actions';
    public backToVisible = true;
    private _filteredData = [];
    private _catDetTaskTypeId: number;
    private _startDate: Date;
    private _endDate: Date;
    private _organizationId: string;

    // region Constructor
    constructor(
        private _facade: ActivityStoreInstructionActionFacade,
        private _route: ActivatedRoute,
        private _datePipe: DatePipe,
        private _excel: ExcelUtility,
        private _facadeBlobStorage: BlobStorageFacade,
        public strings: Strings
    ) {
    }

    // region EventHandlers
    ngOnInit() {
        this.isSpanish = this.strings.getLanguageIsSpanish();
        let language = 0;
        if (!this.isSpanish) {
            language = 1;
        }
        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = 'Total';

        this._route.queryParams.subscribe(params => {
            this.StoreId = params['pSt'];
            this._catDetTaskTypeId = params['pType'];
            this._startDate = new Date(params['pStart']);
            this._endDate = new Date(params['pEnd']);
            this._organizationId = params['orgId'];

            if (params['path'] !== undefined) {
                this.path = 'StoreReport';
                this.extras = {
                    queryParams: {
                        'startDate': this._startDate.toDateString(),
                        'endDate': this._endDate.toDateString(),
                        'orgId': this._organizationId
                    }
                };
                this.flag = false;
                this.loading = true;
                this.getReportFromStoreReport();
            } else {
                this.extras = {
                    queryParams: {
                        'startDate': this._startDate.toDateString(),
                        'endDate': this._endDate.toDateString(),
                        'catDetTaskTypeId': this._catDetTaskTypeId,
                        'orgId': this._organizationId
                    }
                };
                this.loading = true;
                this.getReport();
            }
        });
    }

    getReport() {
        this._facade.GetReport(this.StoreId, this._catDetTaskTypeId, this._startDate, this._endDate, this.language).subscribe(result => {
            if (result.completed) {
                if (!this.isSpanish) {
                    result.data.forEach(row => {
                        if (row.lastDateUpdateString != '') {
                            const dateParts = row.endDate.split('/');
                            // month is 0-based, that's why we need dataParts[1] - 1
                            const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                            row.lastDateUpdateString = this._datePipe.transform(dateObject, 'MM/dd/yyyy');
                        }
                    });
                }
                this.rows = result.data;
                this._filteredData = result.data;
            }
            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    getReportFromStoreReport() {
        this._facade.GetReportDetail(this.StoreId, this._startDate, this._endDate, this.language).subscribe(result => {
            if (result.completed) {
                if (!this.isSpanish) {
                    result.data.forEach(row => {
                        if (row.startDate != '') {
                            const dateParts = row.startDate.split('/');
                            // month is 0-based, that's why we need dataParts[1] - 1
                            const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                            row.startDate = this._datePipe.transform(dateObject, 'MM/dd/yyyy');
                        }
                        if (row.endDate != '') {
                            const dateParts = row.endDate.split('/');
                            // month is 0-based, that's why we need dataParts[1] - 1
                            const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                            row.endDate = this._datePipe.transform(dateObject, 'MM/dd/yyyy');
                        }
                    });
                }
                this.rows2 = result.data;
                this._filteredData = result.data;
            }
            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    addAlert(message: String, type: String): void {
        this.alerts = [];
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    downloadLayout() {
        if (this.rows.length > 0) {
            const data: any = [];
            this.rows.forEach(row => {
                let info: any;
                if (this.isSpanish) {
                    info = {
                        [this.strings.GetText(res.Evaluator)] : row.evaluator,
                        [this.strings.GetText(res.RequiredDate)] : this._datePipe.transform(row.requiredDate, 'dd/MM/yyyy'),
                        [this.strings.GetText(res.SolutionDate)] : row.lastDateUpdateString,
                        [this.strings.GetText(res.Instruction)] : row.instruction ,
                        [this.strings.GetText(res.CorrectiveAction)] : row.actionDescription,
                        [this.strings.GetText(res.Status)] : row.status
                    };
                } else {
                    info = {
                        [this.strings.GetText(res.Evaluator)] : row.evaluator,
                        [this.strings.GetText(res.RequiredDate)] : this._datePipe.transform(row.requiredDate, 'MM/dd/yyyy'),
                        [this.strings.GetText(res.SolutionDate)] : row.lastDateUpdateString,
                        [this.strings.GetText(res.Instruction)] : row.instruction ,
                        [this.strings.GetText(res.CorrectiveAction)] : row.actionDescription,
                        [this.strings.GetText(res.Status)] : row.status
                    };
                }
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, 'data');
        } else {
            this.addAlert(this.strings.GetText(res.YouMustConsultInforFirst), 'danger');
        }
    }

    onViewDetail(id: number) {
        /*
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'actid': id,
                'stid': this.StoreId
            }
        };
        this._router.navigate(['action-info'], navigationExtras).then((e) => {});
        */
    }

    updateFilter(event) {
        const val = event.target.value.toLowerCase();

        const keys = Object.keys(this._filteredData[0]);
        this.rows = this._filteredData.filter(function (item) {
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });
    }

      getBlobPhotos(photos: any[]) {
        this.loading = true;
        this.photos_gallery = [];
        this.imageIndexOne = 0;

        if (photos != null &&
            photos.length > 0) {

          photos.forEach(idPhoto => {

            this._facadeBlobStorage.GetBlob(this.StoreId, idPhoto.blobStorId).subscribe(result => {

              if (result.completed) {
                this.loading = false;
                const photo = 'data:image/png;base64,' + result.data.fileBase64;
                this.photos_gallery.push(photo);
                this.photoModal.show();
              } else {
                this.loading = false;
                this.addAlert('<strong>' + this.strings.GetText(res.FailedToGetImages) + '</strong>', 'danger');
              }
            }, error => {
              this.loading = false;
              this.addAlert('<strong>' + this.strings.GetText(res.FailedToGetImages) + '</strong>', 'danger');
            });
          });
        } else {
          this.loading = false;
        }
    }

}
